<template>
  <div>
    <h2 class="h1 main" v-html="topText"></h2>
    <div class="position-relative">
      <h2 class="h1 black animate-h1" :class="[i === activeIndex ? 'active' : '', 'animate-h1-' + i]" v-for="(text, i) in changingTexts" :key="'changing-' + i" v-html="text"></h2>
      <h2 class="h1 height-placeholder" v-html="placeholderText"></h2>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: 0,
      longestIndex: 0
    }
  },
  mounted() {
    let dur = 5000;
    if(this.duration) {
      dur = parseInt(this.duration) * 1000;
    }
    let longest = 0;
    let longestI = 0;
    this.changingTexts.forEach((text, i) => {
      if(longest < text.length) {
        longest = text.length;
        longestI = i;
      }
    });
    this.longestIndex = longestI;

    setInterval(() => {
        let placeholderIndex = null;
        let newIndex = this.activeIndex;
        this.activeIndex = placeholderIndex;
        if(newIndex === this.changingTexts.length - 1) {
          newIndex = 0;
        } else {
          newIndex = newIndex + 1;
        }

        setTimeout(() => {
          this.activeIndex = newIndex;
        }, 300);

    }, dur);
  },
  computed: {
    placeholderText() {
      return this.changingTexts[this.longestIndex];
    }
  },
  props: {
    topText: {
      type: String,
      default: ""
    },
    duration: {
      type: String,
      default: ''
    },
    changingTexts: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.h1 {
  margin-bottom: 0;

  &.height-placeholder {
    opacity: 0;
    pointer-events: none;
  }

  &.animate-h1 {
    color: #FFDD00;
    opacity: 0;
    position: absolute;
    transition: 0.3s all;
    top: 0;
    left: 0;

    &.active {
      opacity: 1;
    }
  }
}
</style>
